<div class="feedback-dialog">
<div *ngIf="!showThankYou; else thankYouTemplate">
  <div class="display-flex padding-dialog dialog-header">
    <div class="float-left">
      <div class="dialog-header-title">
        <img [class] = "isLikeDialog ? 'icon-positive' : 'icon-negative'"  [src]="isLikeDialog ? '../../../assets/icons/icon-positive-feedback.png' : '../../../assets/icons/icon-negative-feedback.png'" alt="" height="22px" />
        <h1>{{ isLikeDialog ? 'Positive Feedback' : 'Negative Feedback' }}</h1>
      </div>      
    </div>
    <div class="float-right">
      <span class="close-dilog" (click)="onCancel()"><img src="../../../assets/icons/icon-close.png" alt="Close" width="16" /></span>
    </div>
  </div>
  <div class="padding-dialog">
    <p class="smalltext">Your feedback is essential for improving product experience.</p>
    <h2>{{ isLikeDialog ? 'How would you rate this response?' : 'What went wrong?'}}</h2>
    <mat-dialog-content class="bottom-div">
    <div class="block">
      <mat-radio-group class="rate-wrapper" [class.read-only]="isReadOnly" [(ngModel)]="selectedOption" [disabled]="isReadOnly">
        @for(option of radioOptions;track option){
          <mat-radio-button [value]="option.feedback_metadata_id"><span class="rad-span">
            <span class="icon-option"><img [src]="'../../../assets/icons/' + option.feedback_value.split(' ').join('-') + '.png'" alt="" height="16px" /></span><span class="txt-option">{{ option.feedback_value }}</span></span>
          </mat-radio-button>        
        }     
      </mat-radio-group>
      <div *ngIf="showError" class="required">
        Please select any one option.
      </div>
    </div>
    <div class="block">
      <label class="txt-label">Comments <span *ngIf="!isReadOnly" class="required">*</span></label>
      <div class="textarea-wrapper">
        <mat-form-field class="entercomments textarea-field" [class.read-only]="isReadOnly" appearance="fill">
          <textarea placeholder="Please add your comments..." matInput [(ngModel)]="additionalInfo" id="Textarea" rows="5" [readonly]="isReadOnly" (ngModelChange)="onAdditionalInfoChange($event)"></textarea>
        </mat-form-field>
        <div *ngIf="!isReadOnly" class="mic-btn-wrapper">
          <app-speech-to-text (contentClicked)="handleSpeechContent($event)" position="bottom-right"></app-speech-to-text>
        </div>
      </div>
      <div *ngIf="commentError" class="required">
        Please provide comments for disliking.
      </div>
    </div>
  </mat-dialog-content>
    <div *ngIf="isEvaluat" class="wait-msg"> Please wait, Evaluating your feedback...</div>
    <div *ngIf="isPosSubmit" class="wait-msg"> Please wait, Submitting your feedback...</div>
  </div>
<mat-dialog-actions>
  <button class="btn-white btn-dialog-cancel" mat-button (click)="onCancel()">Cancel</button>
  <button class="btn-red" [class.read-only]="isReadOnly" mat-button color="primary" (click)="onSubmit()" [disabled]="isEvaluat || isReadOnly">Submit</button>
</mat-dialog-actions>
</div>
<ng-template #thankYouTemplate>
  <span mat-dialog-title>Thank You for the Feedback!</span>
  <div mat-dialog-content>
    <span>We will work on it.</span>
  </div>
  <div mat-dialog-actions>
    <button mat-button (click)="onNoClick()">Close</button>
  </div>
</ng-template>
<ng-template #alertTemplate let-data let-dialogRef="dialogRef">
  <!-- evaluation-dialog -->
  <div class="feedback-dialog">
  <div class="display-flex padding-dialog dialog-header">
    <div class="float-left">
      <div class="dialog-header-title">
        <img [class] = "isLikeDialog ? 'icon-positive' : 'icon-negative'"  [src]="isLikeDialog ? '../../../assets/icons/icon-positive-feedback.png' : '../../../assets/icons/icon-negative-feedback.png'" alt="" height="22px" />
        <h1>{{ data.title }}</h1>
      </div>      
    </div>
    <div class="float-right">
      <span class="close-dilog" (click)="dialogRef.close()"><img src="../../../assets/icons/icon-close.png" alt="Close" width="16" /></span>
    </div>
  </div>
  <!-- <h1 mat-dialog-title>
    {{ data.title }}
  </h1> -->
  <mat-dialog-content>
    <div class="padding-dialog">
      <p class="message">{{ data.message }}</p>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button color="primary" class="btn-red" (click)="dialogRef.close()">Close</button>
  </mat-dialog-actions>
</div>
</ng-template>


</div>